import { Component, Input, OnInit } from '@angular/core';
import { AppUserState } from '../../stores/states/app.state';

@Component({
  selector: 'app-profile-image',
  templateUrl: './profile-image.component.html',
  styleUrls: ['./profile-image.component.scss'],
})
export class ProfileImageComponent implements OnInit {
  @Input() member!: AppUserState | null;
  @Input() config: any = {
    size: 'w-8 h-8 text-sm',
  };

  defaultColor = '#6f83f7';

  ngOnInit(): void {
    this.assignColor();
  }

  assignColor(): void {
    if (!this.member || this.member.bgColor) {
      return;
    }

    const assignedColors = JSON.parse(
      localStorage.getItem('assignedMemberColors') || '{}',
    );

    const color = this.getRandomHexColor();
    assignedColors[this.member.sub] = color;

    localStorage.setItem(
      'assignedMemberColors',
      JSON.stringify(assignedColors),
    );

  }

  getRandomHexColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  get initials() {
    if (this.member) {
      const nameInitial = this.member.name ? this.member.name.charAt(0).toUpperCase() : '';
      const lastNameInitial = this.member.lastName ? this.member.lastName.charAt(0).toUpperCase() : '';
      return `${nameInitial}${lastNameInitial}`;
    }
    return '';
  }
}
